import {
    APPEAR_COMPONENT_DURATION, appearComponent,
} from 'components/Embed/styles/questionnaire'

import {
    button, buttonText,
} from 'components/Button/styles/ButtonView'

/* eslint-disable sort-keys */
export const buttonWrapper = {
    display: 'flex',
    width: '100%',
    margin: '5px 0',
    justifyContent: 'center',
    a: {
        span: {
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
        },
    },
    button: {
        justifyContent: 'space-between',
        width: '100%',
        span: {
            textAlign: 'center',
            width: '100%',
        },
        padding: '$button',
    },
    variants: {
        lightBot: {true: {}},
        currentElement: {true: {}},
        clearAfter: {true: {'& + *': {clear: 'both'}}},
        align: {
            center: {
                'justifyContent': 'center',
                '> div': {width: 'auto'},
            },
            right: {
                'justifyContent': 'flex-end',
                '> div': {width: 'auto'},
            },
            left: {
                'justifyContent': 'flex-start',
                '> div': {width: 'auto'},
            },
        },
        inline: {
            true: {
                display: 'inline-flex',
                paddingRight: '10px',
                width: 'auto',
            },
        },
        textAlign: {
            center: {},
            left: {
                'button > span': {textAlign: 'left'},
                '&& a > span': {justifyContent: 'flex-start'},
            },
            right: {
                'button > span': {textAlign: 'right'},
                '&& a > span': {justifyContent: 'flex-end'},
            },
        },
        hide: {
            true: {
                'visibility': 'hidden',
                'height': 0,
                'padding': 0,
                'overflow': 'hidden',
                '&& a': {justifyContent: 'flex-start'},
            },
            right: {
                'button > span': {textAlign: 'right'},
                '&& a': {justifyContent: 'flex-end'},
            },
        },
    },
    compoundVariants: [{
        lightBot: true,
        currentElement: true,
        css: {
            visibility: 'hidden',
            animation: `${appearComponent} ${APPEAR_COMPONENT_DURATION}s $$delay`,
            animationFillMode: 'forwards',
        },
    },
    {
        inline: true,
        align: 'left',
        css: {
            width: 'auto',
            float: 'left',
            display: 'block',
        },
    },
    {
        inline: true,
        align: 'right',
        css: {
            width: 'auto',
            float: 'right',
            display: 'block',
            paddingRight: 0,
        },
    }],
}

export const buttonInner = {
    display: 'flex',
    maxWidth: '$$maxWidth',
    width: '100%',
}

export const buttonIcon = {
    display: 'flex',
    alignItems: 'center',
}

export const link = {
    ...button,
    '&&': {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        textDecoration: 'none',
    },
}

export const linkText = {...buttonText}
